import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=ca068ad0&scoped=true"
import script from "./VideoCard.vue?vue&type=script&lang=js"
export * from "./VideoCard.vue?vue&type=script&lang=js"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=ca068ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca068ad0",
  null
  
)

export default component.exports